import { createSlice } from "@reduxjs/toolkit";
import { add, remove } from "lodash";

interface UnderwritingStateRedux {
  refreshUwHome: boolean;
  refreshStatementJobs: boolean;
  refreshFormData: boolean;
  refreshGstJobs: boolean;
  verifyGstJobs: string[];
  refreshRevenueClassification: string | null;
}

const INITIAL_STATE: UnderwritingStateRedux = {
  refreshUwHome: false,
  refreshStatementJobs: false,
  refreshFormData: false,
  refreshGstJobs: false,
  verifyGstJobs: [],
  refreshRevenueClassification: null,
};

const underwritingSlice = createSlice({
  name: "underwriting",
  initialState: INITIAL_STATE,
  reducers: {
    setRefreshUwHome: (state, actions) => {
      state.refreshUwHome = actions.payload;
    },
    setRefreshStatementJobs: (state, actions) => {
      state.refreshStatementJobs = actions.payload;
    },
    setRefreshFormData: (state, actions) => {
      state.refreshFormData = actions.payload;
    },
    setRefreshGstJobs: (state, actions) => {
      state.refreshGstJobs = actions.payload;
    },
    setRefreshRevenueClassification: (state, actions) => {
      state.refreshRevenueClassification = actions.payload;
    },
    addVerifyGstJob: (state, actions) => {
      const jobId = actions.payload;
      if (!state.verifyGstJobs.includes(jobId)) {
        state.verifyGstJobs.push(jobId);
      }
    },
    removeVerifyGstJob: (state, actions) => {
      const jobIds = actions.payload;
      state.verifyGstJobs = state.verifyGstJobs.filter(
        (jobId) => !jobIds.includes(jobId)
      );
    },
  },
});

export const {
  setRefreshUwHome,
  setRefreshStatementJobs,
  setRefreshFormData,
  setRefreshGstJobs,
  setRefreshRevenueClassification,
  addVerifyGstJob,
  removeVerifyGstJob,
} = underwritingSlice.actions;

export const underwritingReducer = underwritingSlice.reducer;
